export const articles = [
  {
    slug: '2024-guohuo-shouji-pingce',
    title: '2024年国产旗舰手机横评：谁才是真正的性价比之王',
    excerpt: '华为、小米、OPPO、vivo四大国产旗舰机全面对比，从性能、影像、续航到性价比，一文告诉你哪款最值得入手。',
    content: `<p>2024年，国产手机市场迎来了又一次大爆发。华为携麒麟芯片强势回归，小米持续冲击高端，OPPO和vivo在影像赛道上一路狂奔。面对琳琅满目的国产旗舰，消费者该如何选择？</p>
    <h2>性能对决：芯片之争</h2>
    <p>华为Mate 70 Pro搭载新一代麒麟9100芯片，采用先进制程工艺，性能较上一代提升超过30%。小米15 Pro则选择了高通骁龙8 Gen 4，在AI算力上有着明显优势。OPPO Find X8 Pro和vivo X200 Pro分别搭载天玑9400和骁龙8 Gen 4，四款旗舰在性能上各有千秋。</p>
    <p>实际测试中，日常使用场景下四款手机的表现都非常流畅，差距主要体现在大型游戏和多任务处理上。华为Mate 70 Pro凭借鸿蒙系统的深度优化，在系统流畅度上略胜一筹。</p>
    <h2>影像系统：国产影像崛起</h2>
    <p>如果说前几年国产手机还在追赶国际品牌，那么2024年，国产旗舰的影像系统已经实现了全面超越。华为的XMAGE影像系统、小米的徕卡光学、OPPO的哈苏人像、vivo的蔡司自然色彩，每一家都有独特的影像风格。</p>
    <p>在夜景拍摄方面，华为Mate 70 Pro凭借可变光圈和超大底传感器，暗光表现最为出色。而人像拍摄则是vivo X200 Pro的强项，蔡司光学加持下的人像虚化效果自然通透。</p>
    <h2>续航与充电</h2>
    <p>国产手机在快充技术上一直走在世界前列。小米15 Pro支持120W有线快充和80W无线快充，15分钟即可充满。华为Mate 70 Pro配备了6000mAh超大电池，续航能力傲视群雄。</p>
    <h2>综合评价：谁是性价比之王</h2>
    <p>综合来看，如果追求均衡体验，小米15 Pro是性价比最高的选择；如果看重影像和系统生态，华为Mate 70 Pro值得考虑；如果预算有限但想要旗舰体验，OPPO Find X8 Pro是很好的选择。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Four%20Chinese%20flagship%20smartphones%20lined%20up%20on%20minimalist%20white%20surface%2C%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20clean%20comparison%20layout&width=1200&height=630&seq=article-phone-01&orientation=landscape',
    category: 'keji-dianzi',
    categoryName: '科技电子',
    author: '国货研究员',
    date: '2024-12-15',
    readTime: '12分钟',
    tags: ['华为', '小米', '旗舰手机', '性价比', '横评'],
    featured: true,
  },
  {
    slug: 'guochao-pinpai-anzou-shijie',
    title: '从中国制造到中国创造：这些国货品牌正在走向世界',
    excerpt: '大疆、安踏、花西子……越来越多的国货品牌不再满足于国内市场，它们正以创新的产品和独特的设计征服全球消费者。',
    content: `<p>曾经，"Made in China"在国际市场上意味着廉价和低质。但今天，越来越多的中国品牌正在用实力改变这一刻板印象。从大疆的无人机到安踏的运动鞋，从花西子的彩妆到蔚来的新能源汽车，中国品牌正在全球市场崭露头角。</p>
    <h2>大疆：定义全球无人机市场</h2>
    <p>大疆创新已经占据全球消费级无人机市场超过70%的份额。从最初的航拍无人机到今天的口袋云台相机、运动相机，大疆凭借持续的创新和技术积累，成为了让世界瞩目的中国科技品牌。</p>
    <h2>安踏：从晋江走向世界</h2>
    <p>安踏集团通过收购FILA中国业务、Amer Sports等国际品牌，成功打造了多品牌矩阵。2024年，安踏品牌的营收已经超越阿迪达斯大中华区，成为中国市场第二大运动品牌。</p>
    <h2>花西子：东方美学的全球表达</h2>
    <p>花西子以"东方彩妆，以花养妆"的理念，将中国传统美学与现代彩妆工艺相结合。其独具特色的雕花口红和蜜粉，在海外社交媒体上频频引发热议，成为中国文化输出的新名片。</p>
    <h2>中国品牌全球化的启示</h2>
    <p>这些品牌成功的背后，是中国制造业从"跟跑"到"并跑"再到"领跑"的缩影。技术创新、品质提升和文化自信，是中国品牌走向世界的三大法宝。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20brands%20products%20displayed%20on%20world%20map%20background%2C%20cream%20tones%2C%20soft%20lighting%2C%20editorial%20style%2C%20global%20business%20concept%2C%20minimalist%20composition&width=1200&height=630&seq=article-global-01&orientation=landscape',
    category: 'keji-dianzi',
    categoryName: '科技电子',
    author: '品牌观察员',
    date: '2024-12-10',
    readTime: '10分钟',
    tags: ['国潮品牌', '全球化', '大疆', '安踏', '花西子'],
    featured: true,
  },
  {
    slug: 'guohuo-hufupin-tuiijian',
    title: '秋冬换季护肤指南：这些国货护肤品比大牌更好用',
    excerpt: '换季时节皮肤敏感干燥？精选8款口碑国货护肤品，从洁面到面霜，百元价位享受千元品质。',
    content: `<p>秋冬换季，气温骤降、空气干燥，皮肤容易出现干燥、脱皮、泛红等问题。很多人第一反应是去买昂贵的国际大牌护肤品，但其实许多国货品牌在成分和效果上完全不输国际大牌，价格却亲民得多。</p>
    <h2>洁面篇：温和清洁是第一步</h2>
    <p>至本舒颜修护洁面乳是敏感肌的救星，氨基酸配方温和不刺激，洗完不紧绷。价格不到百元，却有着堪比大牌的洗感。珀莱雅双抗洁面则在清洁力的基础上加入了抗氧化成分，适合日常使用。</p>
    <h2>精华篇：功效护肤的核武器</h2>
    <p>薇诺娜舒敏保湿修护精华液是针对敏感肌的王牌产品，含有马齿苋提取物和云南特色植物成分，修护皮肤屏障效果显著。润百颜玻尿酸次抛精华则主打补水保湿，次抛设计干净卫生。</p>
    <h2>面霜篇：锁住水分的关键</h2>
    <p>玉泽皮肤屏障修护保湿霜被誉为"国货修护面霜天花板"，含有神经酰胺和多种植物油脂，保湿修护一步到位。相宜本草红景天焕亮面霜则加入了红景天提取物，在保湿的同时提亮肤色。</p>
    <h2>总结</h2>
    <p>国货护肤品近年来在研发上投入巨大，许多产品的成分和配方已达国际水准。选择适合自己的产品，比盲目追求大牌更重要。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20skincare%20products%20arranged%20on%20marble%20surface%20with%20autumn%20leaves%2C%20cream%20background%2C%20warm%20soft%20lighting%2C%20editorial%20beauty%20photography%2C%20minimalist%20composition&width=1200&height=630&seq=article-skincare-01&orientation=landscape',
    category: 'meirong-hufu',
    categoryName: '美妆护肤',
    author: '护肤达人小美',
    date: '2024-12-08',
    readTime: '8分钟',
    tags: ['护肤', '换季', '国货护肤品', '敏感肌', '保湿'],
    featured: true,
  },
  {
    slug: 'zhineng-jiaju-guohuo-tuiijian',
    title: '打造智能家居，这些国货智能设备让生活品质翻倍',
    excerpt: '从扫地机器人到智能门锁，从智能音箱到电动窗帘，一文盘点最值得入手的国货智能家居产品。',
    content: `<p>智能家居已经不再是科幻电影中的场景。随着小米、华为等品牌的持续发力，国货智能家居产品在性价比和生态体验上已经遥遥领先。今天就来盘点一下那些真正能提升生活品质的国货智能设备。</p>
    <h2>扫地机器人：懒人福音</h2>
    <p>小米扫地机器人系列一直是性价比的代名词。最新的小米全能扫拖机器人2代，支持自动集尘、自动清洗拖布、自动烘干，真正做到了解放双手。追觅、石头等国产品牌也在高端市场不断创新。</p>
    <h2>智能门锁：安全与便利兼得</h2>
    <p>鹿客、凯迪仕等国产品牌的智能门锁，支持指纹、人脸识别、手机APP等多种开锁方式。小米智能门锁更是深度融入了米家生态，可以与家中其他智能设备联动。</p>
    <h2>智能音箱与中控</h2>
    <p>小爱同学、天猫精灵等国产智能音箱已经走进千家万户。它们不仅能播放音乐、查询信息，更是智能家居的中枢控制中心。一句"小爱同学，我回家了"，就能自动开灯、开空调、播放音乐。</p>
    <h2>总结</h2>
    <p>相比国际品牌，国货智能家居产品在本地化服务、生态整合和性价比方面有着明显优势。从一两件单品开始，逐步打造属于自己的智能家居系统。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20smart%20home%20devices%20in%20bright%20living%20room%2C%20cream%20walls%2C%20natural%20light%2C%20editorial%20interior%20photography%2C%20minimalist%20tech%20lifestyle&width=1200&height=630&seq=article-smarthome-01&orientation=landscape',
    category: 'keji-dianzi',
    categoryName: '科技电子',
    author: '数码极客阿杰',
    date: '2024-12-05',
    readTime: '9分钟',
    tags: ['智能家居', '扫地机器人', '智能门锁', '小米', '智能音箱'],
    featured: false,
  },
  {
    slug: 'guohuo-yundongxie-pingce',
    title: '国产跑鞋大横评：500元以内哪些最值得买',
    excerpt: '安踏、李宁、特步、361°四大国产品牌跑鞋实测对比，从缓震、支撑、透气到性价比全面分析。',
    content: `<p>跑步是门槛最低的运动之一，一双好的跑鞋至关重要。近年来，国产运动品牌在跑鞋技术上突飞猛进，碳板、氮科技、䨻科技等黑科技层出不穷。今天就来看看500元以内的国产跑鞋，哪些真正值得购买。</p>
    <h2>安踏 C37 4.0：全能型选手</h2>
    <p>安踏C37系列一直是入门跑鞋的标杆产品。4.0版本采用了升级的氮科技中底，回弹率提升至70%以上。鞋面采用MONO纱材质，透气性出色。适合5-10公里的日常训练。</p>
    <h2>李宁 赤兔7 PRO：进阶跑者的选择</h2>
    <p>李宁赤兔系列定位于进阶训练。7 PRO版本搭载了李宁䨻科技中底，轻量化表现突出。中底内嵌尼龙玻纤板，提供了不俗的推进力。适合配速较快的跑者。</p>
    <h2>特步 160X 3.0：碳板竞速</h2>
    <p>特步160X系列是国产碳板跑鞋的代表作。3.0版本改进了碳板弧度，滚动感更加流畅。虽然价格略超500元，但考虑到性能，性价比依然突出。</p>
    <h2>总结</h2>
    <p>500元以内的国产跑鞋，已经完全能满足大多数跑者的需求。新手推荐安踏C37 4.0，有基础的跑者可以试试李宁赤兔7 PRO。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Four%20pairs%20of%20Chinese%20brand%20running%20shoes%20lined%20up%20on%20track%20surface%2C%20cream%20background%2C%20soft%20lighting%2C%20editorial%20sports%20photography%2C%20dynamic%20composition&width=1200&height=630&seq=article-shoes-01&orientation=landscape',
    category: 'fushi-xiebao',
    categoryName: '服饰鞋包',
    author: '跑鞋测评师',
    date: '2024-12-01',
    readTime: '11分钟',
    tags: ['跑鞋', '安踏', '李宁', '特步', '运动装备'],
    featured: false,
  },
  {
    slug: 'zhongguo-chaye-zhinan',
    title: '中国茶入门指南：从零开始认识六大茶类',
    excerpt: '绿茶、红茶、乌龙茶、白茶、黄茶、黑茶……中国六大茶类全解析，附精选国货茶叶品牌推荐。',
    content: `<p>中国是茶的故乡，茶文化源远流长。面对琳琅满目的茶叶品类，很多新手不知从何入手。本文带你从零开始，全面了解中国六大茶类和值得信赖的国货茶叶品牌。</p>
    <h2>绿茶：最受欢迎的茶类</h2>
    <p>绿茶是不发酵茶，保留了茶叶最多的天然物质。西湖龙井、碧螺春、黄山毛峰都是绿茶中的佼佼者。绿茶口感清新，适合春夏饮用。推荐品牌：卢正浩、谢裕大。</p>
    <h2>红茶：温暖醇厚的选择</h2>
    <p>红茶是全发酵茶，茶汤红艳明亮，口感醇厚甘甜。正山小种是世界红茶的鼻祖，金骏眉是红茶中的极品。推荐品牌：正山堂、祁门红茶。</p>
    <h2>乌龙茶：半发酵的魅力</h2>
    <p>乌龙茶介于绿茶和红茶之间，既有绿茶的清香，又有红茶的醇厚。铁观音、大红袍、凤凰单丛都是乌龙茶的代表。推荐品牌：八马茶业、武夷星。</p>
    <h2>白茶、黄茶、黑茶</h2>
    <p>白茶以福鼎白茶最为著名，黄茶中的君山银针是茶中珍品，黑茶中的普洱茶越陈越香。推荐品牌：品品香、大益。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20tea%20ceremony%20set%20with%20six%20types%20of%20tea%20leaves%20displayed%20on%20wooden%20table%2C%20cream%20background%2C%20warm%20soft%20lighting%2C%20editorial%20photography%2C%20traditional%20Chinese%20aesthetic&width=1200&height=630&seq=article-tea-01&orientation=landscape',
    category: 'meishi-yinpin',
    categoryName: '美食饮品',
    author: '茶文化爱好者',
    date: '2024-11-28',
    readTime: '10分钟',
    tags: ['中国茶', '绿茶', '红茶', '乌龙茶', '茶叶推荐'],
    featured: false,
  },
];

export const articleCategories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'keji-dianzi', name: '科技电子' },
  { slug: 'meirong-hufu', name: '美妆护肤' },
  { slug: 'fushi-xiebao', name: '服饰鞋包' },
  { slug: 'meishi-yinpin', name: '美食饮品' },
  { slug: 'riyong-baihuo', name: '日用百货' },
  { slug: 'jiaju-jiazhuang', name: '家居家装' },
];